import { Link, NavLink } from 'react-router-dom'
import {
  FOOTER_ADDRESS,
  FOOTER_EMAIL,
  FOOTER_LEGAL,
  FOOTER_MENU,
  FOOTER_REQUISITES,
  FOOTER_SCHEDULE,
  FOOTER_SOCIALS,
} from '@/constants/footer'
import { HEADER_PHONE } from '@/constants/navigation'
import { ROUTES } from '@/constants/routes'
import './Footer.css'

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__col footer__col--brand">
          <NavLink to={ROUTES.HOME} className="footer__logo" end>
            <img src="/logo.svg" alt="MetaMarket" className="footer__logo-image" />
          </NavLink>
          <ul className="footer__requisites">
            {FOOTER_REQUISITES.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </div>

        <div className="footer__col footer__col--menu">
          <a href={`tel:${HEADER_PHONE.replace(/\D/g, '')}`} className="footer__contact">
            <img src="/icons/phone.svg" alt="" className="footer__contact-icon" />
            {HEADER_PHONE}
          </a>
          <nav className="footer__nav" aria-label="Меню в подвале">
            <span className="footer__nav-title">Меню:</span>
            <ul className="footer__nav-list">
              {FOOTER_MENU.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="footer__nav-link">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="footer__col footer__col--contacts">
          <a href={`mailto:${FOOTER_EMAIL}`} className="footer__contact">
            <img src="/icons/mail.svg" alt="" className="footer__contact-icon" />
            {FOOTER_EMAIL}
          </a>
          <address className="footer__address">
            {FOOTER_ADDRESS.map((line) => (
              <span key={line} className="footer__line">
                {line}
              </span>
            ))}
          </address>
          <p className="footer__schedule">
            <span className="footer__line footer__line--title">Режим работы:</span>
            {FOOTER_SCHEDULE.map((line) => (
              <span key={line} className="footer__line">
                {line}
              </span>
            ))}
          </p>
        </div>

        <div className="footer__col footer__col--actions">
          <a href="#lead" className="footer__button">
            Заказать авто
          </a>
          <ul className="footer__socials">
            {FOOTER_SOCIALS.map((item) => (
              <li key={item.label}>
                <a
                  href={item.href}
                  className="footer__social"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={item.label}
                >
                  <img src={item.icon} alt="" className="footer__social-icon" />
                </a>
              </li>
            ))}
          </ul>
        </div>

        <ul className="footer__legal">
          {FOOTER_LEGAL.map((item) => (
            <li key={item.to}>
              <Link to={item.to} className="footer__legal-link">
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  )
}
